import { useMenuQuery } from "../../core/hooks/use-menu-query.js";
import { useCurrentProductStore } from "../../core/hooks/use-current-product-store.js";
import { generateBreadcrumbs } from "../utils/breadcrumbs.js";
import "react";
import { jsx } from "react/jsx-runtime";
import { Breadcrumbs, Skeleton } from "@tecsinapse/cortex-react";
import { useLocation } from "react-router-dom";
//#region src/modules/header/components/breadcrumbs.tsx
var Breadcrumbs$1 = () => {
	const { data: menu, isLoading } = useMenuQuery();
	const { pathname } = useLocation();
	const currentProduct = useCurrentProductStore((state) => state.currentProduct);
	const breadcrumbs = generateBreadcrumbs(menu?.menus ?? [], pathname, currentProduct);
	return /* @__PURE__ */ jsx("div", {
		className: "max-w-360 w-[calc(100%-32px)] my-deca mx-auto hidden sm:flex",
		children: isLoading ? /* @__PURE__ */ jsx(Skeleton, { className: "h-7.75 rounded-mili w-full" }) : /* @__PURE__ */ jsx(Breadcrumbs, { breadcrumbs })
	});
};
//#endregion
export { Breadcrumbs$1 as Breadcrumbs };
